import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Text, Stack, Icon, IconButton, IIconProps, ActionButton } from '@fluentui/react';
import COLOR from "../../Styles/Colors";
import Type from "../../Redux/Type";
import PolygonTrichDo from "../Trichdo/Polygon";
import { useSelector, useDispatch } from 'react-redux';
import { onLoadQHChiTietTanChau, onLoadQuyHoachPolygon } from '../../Containers/QuyHoach';
import { checkQuyenXemQuyHoach, formatNumber } from './../../Containers/MainController';


const ButtonShowQuyHoachIcon: IIconProps = { iconName: 'GenericScan' };

const PanelInfo = forwardRef((props, ref) => {
    const [data, setData] = useState('');
    const [showIndex, setShowIndex] = useState(0);
    const [className, setClassName] = useState('animated-panel-info-off');
    const listQuyHoach = useSelector(state => state.quyHoachInfo);


    useImperativeHandle(ref, () => ({
        onShowCardInfo(dataFromParent) {
            setData(dataFromParent)
            if (!data)
                setClassName('animated-panel-info')
            else if (showIndex)
                setShowIndex(0)
            else if (!showIndex)
                setShowIndex(1)
        }
    }));

    const onShowOffCardInfo = () => {
        setClassName('animated-panel-info-off');
        setTimeout(() => setData(''), 300)
    }


    const getQuyHoachList = () => {
        let { SOTO, SOTHUA, MaDVHC } = data;
        if (SOTO && SOTHUA && MaDVHC) {
            let checkExist = listQuyHoach.filter(e => (
                e.SoTo === SOTO.trim()
                && e.SoThua === SOTHUA.trim()
                && e.MaDvhc === MaDVHC.toString().trim()
            ));
            if (checkExist.length)
                return checkExist[0].data;
        }
        return []
    }

    return (
        data ?
            !showIndex ?
                <CardInfo1
                    listQuyHoach={getQuyHoachList()}
                    onClose={onShowOffCardInfo}
                    className={className}
                    data={data}
                />
                :
                <CardInfo2
                    listQuyHoach={getQuyHoachList()}
                    onClose={onShowOffCardInfo}
                    className={className}
                    data={data}
                />
            :
            <div />
    )
})

const CardInfo1 = props => (
    <CardInfo
        listQuyHoach={props.listQuyHoach}
        onClose={props.onClose}
        className={props.className}
        data={props.data}
    />
)

const CardInfo2 = props => (
    <CardInfo
        listQuyHoach={props.listQuyHoach}
        onClose={props.onClose}
        className={props.className}
        data={props.data}
    />
)


const CardInfo = props => {
    const data = props.data;
    const listQuyHoach = props.listQuyHoach
    const { makerPosition } = useSelector(state => state.hienTrang);
    const dispatch = useDispatch();
    // const { showQuyHoach, typeActive} = useSelector(state => state.quyHoach);
    const userInfo = useSelector(state => state.userInfo);

    const onShowQuyHoach = (key) => {

        // console.log(userInfo)
        if (checkQuyenXemQuyHoach(null, userInfo.Username) == true) {
            let typeActiveTerm = {};
            typeActiveTerm.coordinate = makerPosition || { lat: parseFloat(0), lng: parseFloat(0) }
            if (key === 'QH_TCU_SDD_VN2000') // chỗ làm tạm load của tân châu
            {
                key = 'CTSDDTTCT';
                typeActiveTerm.key = key
                dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'typeActive', value: typeActiveTerm });
                onLoadQHChiTietTanChau();
            }
            else {

                typeActiveTerm.key = key
                dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'typeActive', value: typeActiveTerm });
                onLoadQuyHoachPolygon(key)
            }

            //
            dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'showQuyHoach', value: true });
        }
        else {
            alert("Quy hoạch không có thông tin")
        }

    }

    const getQuyHoachList = () => {
        let { SOTO, SOTHUA, MaDVHC } = data;
        if (SOTO && SOTHUA && MaDVHC) {
            let checkExist = listQuyHoach.filter(e => (
                e.SoTo === SOTO.trim()
                && e.SoThua === SOTHUA.trim()
                && e.MaDvhc === MaDVHC.toString().trim()
            ));
            if (checkExist.length)
                return checkExist[0].data;
        }
        return []
    }

    return (
        <div style={styles.infoView} className={props.className}>
            <div style={styles.infoHeader}>
                <Text styles={styles.infoTitle}>Thông tin thửa đất</Text>
                <IconButton
                    iconProps={{ iconName: 'ChromeClose' }}
                    title="Đóng"
                    styles={styles.closeInfo}
                    onClick={props.onClose}
                />
            </div>
            <div style={styles.infoContainer}>
                <Stack tokens={{ childrenGap: 10 }}>
                    <Stack horizontal horizontalAlign='space-between'>
                        <Text styles={styles.text}>Bản đồ :
                            <Text styles={{ root: { fontWeight: 'bold' } }}> Tờ số {data.SOTO}, thửa số {data.SOTHUA} </Text>
                        </Text>
                        {/* <Text styles={{ root: { color: COLOR.white } }}>Diện tích :
                            <Text styles={{ root: { fontWeight: 'bold' } }}> {data.DienTich} </Text>
                            ㎡
                        </Text> */}
                    </Stack>
                    <Stack horizontal horizontalAlign='space-between'>
                        <Text styles={{ root: { color: COLOR.white } }}>Diện tích :
                            <Text styles={{ root: { fontWeight: 'bold' } }}> {data.DienTich} </Text>
                            ㎡
                        </Text>
                    </Stack>

                    <Stack>
                        <Text styles={{ root: { color: COLOR.white } }}>Mục đích sử dụng :</Text>
                        {
                            Array.isArray(data.MucDichSDD) && data.MucDichSDD.length ?
                                data.MucDichSDD.map((element, i) => (
                                    <Stack key={i} horizontal verticalAlign='center' style={{ marginLeft: 10 }}>
                                        <div style={styles.squareIcon(element.color)} />
                                        <Text styles={styles.text}>{element.name}</Text>
                                    </Stack>
                                ))
                                :
                                <Text styles={styles.text}>Đang cập nhật</Text>
                        }
                    </Stack>
                    <Stack>
                        <Text styles={{ root: { color: COLOR.white } }}>Địa chỉ :   <Icon iconName='POI' styles={styles.titleIcon} />
                            <Text styles={styles.text}>{data.DiaChiThuaDat ? data.DiaChiThuaDat : "Đang cập nhật"}</Text>
                        </Text>
                    </Stack>
                    <Stack>
                        {/* <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign='center'>
                            <Icon iconName='MapLayers' styles={styles.titleIcon} />
                            <Text variant='medium' styles={styles.text}>Quy hoạch</Text>
                            {listQuyHoach.length > 0 ?
                                <ActionButton iconProps={ButtonShowQuyHoachIcon}
                                    allowDisabledFocus
                                    styles={styles.btnStyles}
                                    onClick={() => { onShowQuyHoach(listQuyHoach[0]["maquyhoach"]) }}
                                >
                                    Xem quy hoạch
                                </ActionButton> : null
                            }

                        </Stack> */}


                        <Text styles={{ root: { color: COLOR.white } }}>Quy hoạch sử dụng đất: </Text>
                        <Text styles={styles.text}>{"Đang cập nhật"}</Text>
                        {/* {listQuyHoach.length ?
                            listQuyHoach.map((element, i) => {
                                if (element && element.maquyhoach !== "KHSDD")
                                    return (
                                        <Stack key={i.toString()} horizontal tokens={{ childrenGap: 8 }}>
                                            <div style={styles.squareIcon(element.color)} />
                                            <Text styles={styles.text} variant='smallPlus'>{element.quyhoach}</Text>
                                        </Stack>
                                    )
                            })
                            : <Text styles={styles.text} variant='smallPlus'>Đang cập nhật</Text>
                        } */}
                        <Stack style={{ height: 10 }} />

                        <Text styles={{ root: { color: COLOR.white } }}>Kế hoạch sử dụng đất: </Text>
                        <Text styles={styles.text}>{"Đang cập nhật"}</Text>
                        {/* {listQuyHoach.length ?
                            listQuyHoach.map((element, i) => {
                                if (element && element.maquyhoach === "KHSDD")
                                    return (
                                        <Stack key={i.toString()} horizontal tokens={{ childrenGap: 8 }}>
                                            <div style={styles.squareIcon(element.color)} />
                                            <Text styles={styles.text} variant='smallPlus'>{element.quyhoach}</Text>
                                        </Stack>
                                    )
                            })
                            : <Text styles={styles.text} variant='smallPlus'>Đang cập nhật</Text>
                        } */}



                    </Stack>
                    <Stack  >
                        <Text styles={{ root: { color: COLOR.white } }}>Trạng thái pháp lý:</Text>
                        <Stack horizontal>
                            {data.TrangThaiThuaDat ? <Icon iconName='Shield' styles={styles.titleIcon} /> : null}
                            <Text styles={styles.text}>{data.TrangThaiThuaDat ? data.TrangThaiThuaDat : "Đang cập nhật"}</Text>
                        </Stack>
                    </Stack>

                    <Stack  >
                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign='center'>
                            <Icon iconName='money' styles={styles.titleIcon} />
                            <Text variant='medium' styles={{ root: { color: COLOR.white } }}>Giá đất (Tham khảo)</Text>
                        </Stack>
                        {
                            data.giadat && data.giadat != 0 ?
                                <Stack>
                                    <Text style={{ fontFamily: 'Open Sans', color: COLOR.white }} variant='smallPlus'>{"Tuyến đường: " + ((data.tentuyendu && data.tentuyendu != "NULL") ? data.tentuyendu : "")}</Text>
                                    <Text style={{ fontFamily: 'Open Sans', color: COLOR.white }} variant='smallPlus'>{"Đoạn đường: " + ((data.doanduongd && data.doanduongd != "NULL") ? data.doanduongd : "")}</Text>
                                    <Text style={{ fontFamily: 'Open Sans', color: COLOR.white }} variant='smallPlus'>{("Giá tuyến: " + (data.gia_tuyen ? (formatNumber(data.gia_tuyen) + ' VND') : ""))}</Text>
                                    {/* <Text style={{ fontFamily: 'Open Sans', color: COLOR.white }} variant='smallPlus'>{("Giá đất tham khảo: " + formatNumber(data.giadat) + ' VND')}</Text> */}
                                </Stack>
                                :
                                <Stack horizontal verticalAlign='center' tokens={{ childrenGap: 8 }}>
                                    <Text style={{ fontFamily: 'Open Sans', color: COLOR.white }} variant='smallPlus'>Đang cập nhật</Text>
                                </Stack>
                        }

                        {/* <Text styles={{ root: { color: COLOR.white } }}>Giá đất (tham khảo): {data.giadat && data.giadat != 0 ? (formatNumber(data.giadat) + ' VND') : "Đang cập nhật"} </Text> */}
                        {/* <Stack horizontal>
                            <Icon iconName='Shield' styles={styles.titleIcon} />
                            <Text styles={styles.text}>{data.TrangThaiThuaDat}</Text>
                        </Stack> */}
                    </Stack>
                    {/* {data.Ten1 ?
                        <Stack horizontal>
                            <Icon iconName={'Contact'} styles={styles.infoAccount} />
                            <Stack>
                                <Text styles={styles.infoName}>{data.Ten1}</Text>
                                <Text variant='smallPlus' styles={styles.text}>
                                    SN {data.NamSinh1}
                                    <Icon iconName='LocationDot' styles={{ root: { color: COLOR.white } }} />
                                    {data.DiaChi1}
                                </Text>
                            </Stack>
                        </Stack>
                        : null
                    } */}
                    {/* {data.Ten2 ?
                        <Stack horizontal>
                            <Icon iconName={'Contact'} styles={styles.infoAccount} />
                            <Stack>
                                <Text styles={styles.infoName}>{data.Ten2}</Text>
                                <Text variant='smallPlus' styles={styles.text}>
                                    SN {data.NamSinh2}
                                    <Icon iconName='LocationDot' styles={{ root: { color: COLOR.white } }} />
                                    {data.DiaChi2}
                                </Text>
                            </Stack>
                        </Stack>
                        : undefined
                    } */}
                    <Stack horizontal>
                        {/*<Icon iconName='Nav2DMapView' styles={styles.titleIcon}/>*/}
                        <Text styles={styles.text}>Bản đồ thửa đất</Text>
                    </Stack>
                    <PolygonTrichDo />
                </Stack>
            </div>
        </div>
    )
}

export default PanelInfo;

const styles = {
    infoView: {
        display: 'flex',
        flexDirection: 'column',
    },
    infoHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 10,
        marginBottom: 5
    },
    infoContainer: {
        maxHeight: 300,
        overflowY: 'scroll',
        paddingBottom: 30,
        marginRight: -16,
        paddingRight: 16
    },
    closeInfo: {
        root: {
            height: 40,
            width: 40,
            borderRadius: 0,
            marginRight: -16
        },
        icon: {
            color: '#fff',
            fontSize: 12,
            opacity: .8
        },
        rootHovered: {
            backgroundColor: 'transparent'
        },
        iconHovered: {
            opacity: 1
        }
    },
    btnStyles: {
        rootHovered: {
            color: 'blue'
        },
        icon: { color: 'white', fontSize: 20 },
        iconHovered: { color: 'blue' },
        root: {
            color: COLOR.white
        }
    },
    infoTitle: {
        root: {
            color: COLOR.white,
            fontWeight: 'bold',
            fontSize: 14,
            flex: 1
        }
    },
    squareIcon: (color) => ({
        height: 12,
        width: 12,
        backgroundColor: color || COLOR.white,
        borderRadius: 1,
        border: '1px solid #fff',
        marginRight: 5
    }),
    text: {
        root: {
            color: COLOR.white
        }
    },
    titleIcon: {
        root: {
            color: COLOR.white,
            marginRight: 5
        }
    },
    gender: {
        root: {
            fontSize: 11,
            color: COLOR.white
        }
    },
    infoName: {
        root: {
            fontWeight: 'bold',
            color: COLOR.white
        }
    },
    infoAccount: {
        root: {
            fontSize: 14,
            color: COLOR.white,
            marginRight: 5,
        }
    }
};

